module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('div', {
    staticClass: "centerfull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/graykeys.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_list-head"
  }, [_vm._v("Praise for "), _c('br'), _c('em', [_vm._v("Jane Doe and the Cradle of All Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_list"
  }, [_vm._v("“Immediately exciting and inventive, this is a thrilling story set in a universe made up of multiple worlds . . . Jane is a wonderful character—warm, brave and funny—and the secondary characters are equally charming . . . this action-packed adventure thriller will appeal to a wide range of readers . . . and could well be our next "), _c('span', {
    staticClass: "frontmatter_CMS-ital"
  }, [_vm._v("Nevermoor")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_list-attribute"
  }, [_vm._v("—Angela Crocombe, "), _c('span', {
    staticClass: "frontmatter_CMS-ital"
  }, [_vm._v("Books+Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_list"
  }, [_vm._v("“A fantastic fast-paced exciting adventure set in a magical labyrinth of a manor with rooms that shift, booby traps and a classic bad guy who will stop at nothing to get what he wants. I highly recommend this book for kids 11+.”")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_list-attribute"
  }, [_vm._v("—Dani Solomon, Readings Kids")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cfdef7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/x9781541541771.vue
// module id = 60
// module chunks = 0